export default __webpack_public_path__ + "static/media/newsletter_box_corner.339eaf78.png";